/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';

import s from './styles.module.less';

const Background = ({ className, ...props }) => <div className={clsx(s.fixedBackground, className)} {...props} />;

export default Background;
